import React from "react";
import whatsappIcon from "../assets/icons/white-whatsapp-removebg.png"; // ← your WhatsApp icon image
import "../styles/WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "919950999997"; // Replace with your WhatsApp number
  const message = "Hello SQUAREFEET MARBLE!!!I’m interested in buying your products.Could you please share some more details...";

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <button className="whatsapp-btn" onClick={handleClick}>
      <img src={whatsappIcon} alt="WhatsApp" className="whatsapp-icon" />
    </button>
  );
};

export default WhatsAppButton;
